export default "__VITE_ASSET__bf9d205f__"